<template>
  <Header />
  <div class="empty"></div>
  <div class="app" :class="$route.meta.noBFC ? '' : 'isBFC'">
    <router-view v-slot="{ Component }">
      <transition :name="transitionName">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
  <TabBal v-show="$route.meta.showNav" />
  <div v-if="isAttention" class="fc attention">
    <img v-if="isProduct" src="./assets/images/QRCodeProduct.png" alt="" />
    <img v-else src="./assets/images/QRCodeTest.png" alt="" />
  </div>
</template>
<script>
import TabBal from '@/components/common/TabBal'
import Header from '@/components/common/Header'
import { wxConfigFn, getWXLocation, getWxUserInfo } from '@/api/wx'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    TabBal,
    Header
  },
  computed: {
    ...mapState(['locationInfo', 'formattedAddress', 'position', 'isProduct'])
  },
  data() {
    return {
      transitionName: 'slide-left',
      isAttention: false,
      getLocationInterval: ''
    }
  },
  async created() {
    this.getLocation()
    let data = await getWxUserInfo()
    this.isAttention = !data.IsOk
    this.setPersonWXInfor(data)
    this.getCountOfShoppingCar()
    this.getRegisterUserInfo()
    this.getMyDdefaultCar()
  },
  async mounted() {
    await wxConfigFn()
    // await getWXLocation()
  },
  methods: {
    ...mapActions(['getLocation', 'getCountOfShoppingCar', 'setPersonWXInfor', 'getRegisterUserInfo', 'getMyDdefaultCar'])
  },
  watch: {
    $route(to, from) {
      // 有主级到次级
      sessionStorage.removeItem('getPrice')
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'van-slide-left' // 向左滑动
      } else if (to.meta.index <= from.meta.index) {
        // 由次级到主级
        this.transitionName = 'van-slide-right'
      }
    }
    // 'locationInfo.city'(n) {
    //   let params = { page: 'index', city_name: n }
    //   track(params)
    // },
    // currentCity(n) {
    //   if (this.locationInfo.city === n.name) return
    //   let params = { page: 'index', city_name: n.name }
    //   // track(params)
    // }
  }
}
</script>
<style lang="scss">
.attention {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 100;
}
html,
body {
  height: 100%;
  background: #f5f5f5;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.empty {
  height: 80px;
}
.isBFC {
  > div {
    overflow: auto;
  }
}
.app {
  background: #f5f5f5;
  > div {
    width: 100%;
    height: auto;
    margin: 0 auto;
    -webkit-overflow-scrolling: touch;
    height: calc(100vh - 80px);
  }
  .van-action-sheet__header {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    opacity: 0.95;
  }
  .van-action-sheet__close {
    font-size: 18px;
  }
  .van-action-sheet__content::-webkit-scrollbar {
    display: none;
  }
  .btn {
    background: #3088c5;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  height: 100%;
  will-change: transform;
  transition: all 1500ms;
  position: absolute;
  backface-visibility: hidden;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.van-badge--fixed {
  z-index: 1000;
}
.van-popup.van-dialog {
  border-radius: 0;
  .van-dialog__message {
    text-align: left;
    color: #666666;
  }
  .van-dialog__confirm {
    color: #3088c5;
  }
}
.cb {
  color: #3088c5;
}

// .van-dialog__header {
//   font-size: 16px;
//   text-align: center;
//   color: #333333;
// }
// .van-dialog__message {
//   font-size: 13px;
//   text-align: center;
//   color: #666666;
// }
</style>
